import { CUSTOMER } from 'src/api/CoreApi'
// TODO find a better way to integrate this with the withPermissions HOC?
export const EVENTS_CREATE_ALL = 'events:event:create-all'
export const EVENTS_CREATE_OWN = 'events:event:create-own'
export const EVENTS_DELETE = 'events:event:delete'
export const EVENTS_READ_ALL = 'events:event:read-all'
export const EVENTS_READ_OWN = 'events:event:read-own'
export const EVENTS_CLEAR = 'events:event:clear-event'
export const MAINTENANCE_DELETE =
    'maintenance:maintenance-windows:manual-delete'
export const MAINTENANCE_READ = 'maintenance:maintenance-windows:read'
export const BACKUP_INFO_READ = 'core:backup-info:read'
export const RECURRING_MAINTENANCE_CREATE =
    'maintenance:recurring-maintenance:create'

export default function isAllowed(context, pathname) {
    const entityName = pathname.split('/').pop()
    // If the person is a Cegeka user (not a customer) or has access to more than 1 customer,
    // he/she has access to the customer route.
    if (entityName === CUSTOMER) {
        return context.permissions?.length > 1 || false
    }
    return true
}
